import { Link } from "@tanstack/react-router";
import { Button, buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** Shared actions for marketing error pages (403 / 404 / 500). */
export function ErrorPageActions() {
	return (
		<div className="flex gap-4 justify-center mt-8">
			<Button
				type="button"
				variant="secondary"
				onClick={() => window.history.back()}
			>
				← Go Back
			</Button>
			<Link
				to="/"
				className={cn(buttonVariants({ variant: "default" }), "inline-flex")}
			>
				Home Page
			</Link>
		</div>
	);
}
